"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monospace = {
    0x20: [0, 0, .525],
    0x21: [.622, 0, .525],
    0x22: [.623, -0.333, .525],
    0x23: [.611, 0, .525],
    0x24: [.694, .082, .525],
    0x25: [.694, .083, .525],
    0x26: [.622, .011, .525],
    0x27: [.611, -0.287, .525],
    0x28: [.694, .082, .525],
    0x29: [.694, .082, .525],
    0x2A: [.52, -0.09, .525],
    0x2B: [.531, -0.081, .525],
    0x2C: [.14, .139, .525],
    0x2D: [.341, -0.271, .525],
    0x2E: [.14, 0, .525],
    0x2F: [.694, .083, .525],
    0x30: [.621, .01, .525],
    0x31: [.622, 0, .525],
    0x32: [.622, 0, .525],
    0x33: [.622, .011, .525],
    0x34: [.624, 0, .525],
    0x35: [.611, .01, .525],
    0x36: [.622, .011, .525],
    0x37: [.627, .01, .525],
    0x38: [.621, .01, .525],
    0x39: [.622, .011, .525],
    0x3A: [.431, 0, .525],
    0x3B: [.431, .139, .525],
    0x3C: [.557, -0.055, .525],
    0x3D: [.417, -0.195, .525],
    0x3E: [.557, -0.055, .525],
    0x3F: [.617, 0, .525],
    0x40: [.617, .006, .525],
    0x41: [.623, 0, .525],
    0x42: [.611, 0, .525],
    0x43: [.622, .011, .525],
    0x44: [.611, 0, .525],
    0x45: [.611, 0, .525],
    0x46: [.611, 0, .525],
    0x47: [.622, .011, .525],
    0x48: [.611, 0, .525],
    0x49: [.611, 0, .525],
    0x4A: [.611, .011, .525],
    0x4B: [.611, 0, .525],
    0x4C: [.611, 0, .525],
    0x4D: [.611, 0, .525],
    0x4E: [.611, 0, .525],
    0x4F: [.621, .01, .525],
    0x50: [.611, 0, .525],
    0x51: [.621, .138, .525],
    0x52: [.611, .011, .525],
    0x53: [.622, .011, .525],
    0x54: [.611, 0, .525],
    0x55: [.611, .011, .525],
    0x56: [.611, .007, .525],
    0x57: [.611, .007, .525],
    0x58: [.611, 0, .525],
    0x59: [.611, 0, .525],
    0x5A: [.611, 0, .525],
    0x5B: [.694, .082, .525],
    0x5C: [.694, .083, .525],
    0x5D: [.694, .082, .525],
    0x5E: [.611, -0.46, .525],
    0x5F: [-0.025, .095, .525],
    0x60: [.681, -0.357, .525],
    0x61: [.439, .006, .525],
    0x62: [.611, .006, .525],
    0x63: [.44, .006, .525],
    0x64: [.611, .006, .525],
    0x65: [.44, .006, .525],
    0x66: [.617, 0, .525],
    0x67: [.442, .229, .525],
    0x68: [.611, 0, .525],
    0x69: [.612, 0, .525],
    0x6A: [.612, .228, .525],
    0x6B: [.611, 0, .525],
    0x6C: [.611, 0, .525],
    0x6D: [.436, 0, .525, { ic: .011 }],
    0x6E: [.436, 0, .525],
    0x6F: [.44, .006, .525],
    0x70: [.437, .221, .525],
    0x71: [.437, .221, .525, { ic: .02 }],
    0x72: [.437, 0, .525],
    0x73: [.44, .006, .525],
    0x74: [.554, .006, .525],
    0x75: [.431, .005, .525],
    0x76: [.431, 0, .525],
    0x77: [.431, 0, .525],
    0x78: [.431, 0, .525],
    0x79: [.431, .228, .525],
    0x7A: [.431, 0, .525],
    0x7B: [.694, .083, .525],
    0x7C: [.694, .082, .525],
    0x7D: [.694, .083, .525],
    0x7E: [.611, -0.466, .525],
    0x7F: [.612, -0.519, .525],
    0xA0: [0, 0, .525],
    0x131: [.431, 0, .525],
    0x237: [.431, .228, .525],
    0x2B9: [.623, -0.334, .525],
    0x300: [.611, -0.485, 0],
    0x301: [.611, -0.485, 0],
    0x302: [.611, -0.46, 0],
    0x303: [.611, -0.466, 0],
    0x304: [.577, -0.5, 0],
    0x306: [.611, -0.504, 0],
    0x308: [.612, -0.519, 0],
    0x30A: [.619, -0.499, 0],
    0x30C: [.577, -0.449, 0],
    0x391: [.623, 0, .525],
    0x392: [.611, 0, .525],
    0x393: [.611, 0, .525],
    0x394: [.623, 0, .525],
    0x395: [.611, 0, .525],
    0x396: [.611, 0, .525],
    0x397: [.611, 0, .525],
    0x398: [.621, .01, .525],
    0x399: [.611, 0, .525],
    0x39A: [.611, 0, .525],
    0x39B: [.623, 0, .525],
    0x39C: [.611, 0, .525],
    0x39D: [.611, 0, .525],
    0x39E: [.611, 0, .525],
    0x39F: [.621, .01, .525],
    0x3A0: [.611, 0, .525],
    0x3A1: [.611, 0, .525],
    0x3A2: [.621, .01, .525],
    0x3A3: [.611, 0, .525],
    0x3A4: [.611, 0, .525],
    0x3A5: [.622, 0, .525],
    0x3A6: [.611, 0, .525],
    0x3A7: [.611, 0, .525],
    0x3A8: [.611, 0, .525],
    0x3A9: [.622, 0, .525],
    0x3D2: [.622, 0, .525],
    0x3DC: [.611, 0, .525],
    0x2017: [-0.025, .095, .525],
    0x2032: [.623, -0.334, .525],
    0x2033: [.623, 0, 1.05],
    0x2034: [.623, 0, 1.575],
    0x2044: [.694, .083, .525],
    0x2057: [.623, 0, 2.1],
    0x2206: [.623, 0, .525],
};
//# sourceMappingURL=monospace.js.map